import { render, staticRenderFns } from "./MarketsIcon.vue?vue&type=template&id=127eba22&scoped=true&"
import script from "./MarketsIcon.vue?vue&type=script&lang=js&"
export * from "./MarketsIcon.vue?vue&type=script&lang=js&"
import style0 from "./MarketsIcon.vue?vue&type=style&index=0&id=127eba22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127eba22",
  null
  
)

export default component.exports